import { MessengerV2 } from 'lib-shared-legacy-types';
import first from 'lodash/first';

import { MessengerRow } from './components';

type ListingBodyProps = {
  readonly items: ReadonlyArray<MessengerV2>;
  readonly onRename: (messengerId: string) => void;
  readonly onDelete: (messengerId: string) => void;
  readonly onDuplicateMessenger: (messengerId: string) => void;
  readonly onEditSettings: (messengerId: string) => void;
  readonly onEditFlow: (flowId: string) => void;
  readonly onAudit: (flowId: string) => void;
};

export function ListingBody({ items, ...rest }: ListingBodyProps): JSX.Element {
  const rows = items
    .map((x) => ({
      messengerId: x.id,
      messengerName: x.name,
      flowId: first(x.flows)?.id || '',
    }))
    .filter((x) => x.flowId !== '')
    .map((x) => (
      <MessengerRow
        key={x.messengerId}
        messengerName={x.messengerName}
        onRename={() => rest.onRename(x.messengerId)}
        onDelete={() => rest.onDelete(x.messengerId)}
        onDuplicateMessenger={() => rest.onDuplicateMessenger(x.messengerId)}
        onEditSettings={() => rest.onEditSettings(x.messengerId)}
        onEditFlow={() => rest.onEditFlow(x.flowId)}
        onAudit={() => rest.onAudit(x.flowId)}
      />
    ));

  return <>{rows}</>;
}
